import { Storage } from "aws-amplify";

// Configure Storage with the correct region and bucket
export const configureStorage = () => {
  Storage.configure({
    region: "us-east-1",
    bucket: "sam-bucket-assets",
    level: "public",
    customPrefix: {
      public: "",
    },
  });
};

export default configureStorage;
